import React from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import {fphoto} from '../../../helper/common'
import ConfirmButton from '../button/confirm_button'
import moment from 'moment'
import {FORMAT} from '../../../config/const'

const PopupModal = observer((props) => {
  const {show, toggle, image, link, title} = props

  const onNotShowToday = () => {
    const oneWeekLater = moment(this).add(7, 'days').format(FORMAT.DATE);
    localStorage.setItem('popup_date', oneWeekLater)
    toggle()
  }

  const onLinkBanner = (e) => {
    if (link === '') {
      e.preventDefault()
    }
  }

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{title}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-content-area fs-16 sm-fs-15 f-m p-0'>
          <a href={link} target={'_blank'} onClick={(e) => {onLinkBanner(e)}}><img src={fphoto(image, 'banner')} className='banner_img ph-20' alt={''}/></a>
          <div className='d-center pv-30 sm-pv-20 ph-20 sm-ph-20'>
            <ConfirmButton enabled={true} className={'bd-0 btn-point-pay fs-15 sm-fs-14 f-m d-center'} onClick={() => onNotShowToday()} text={strings.not_show_main_banner} />
            <div className='flex-full' />
            <ConfirmButton enabled={true} className={'bd-0 btn-primary fs-15 sm-fs-14 f-m d-center ml-10'} onClick={toggle} text={strings.close} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default PopupModal
